import React from "react";
import LoadingSpinner from "./LoadingSpinner";

export default function LoadingButton({
  loading,
  children,
  className = "",
  ...props
}) {
  return (
    <button
      {...props}
      disabled={loading || props.disabled}
      className={`inline-flex items-center justify-center gap-2 ${className} ${
        loading ? "opacity-80 cursor-wait" : ""
      }`}
    >
      {loading && <LoadingSpinner size={4} />}
      <span>{children}</span>
    </button>
  );
}
